import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Button, doScrolling, Separator } from 'telia-front-react';
import SearchStore, { CATEGORY_ARCHIVED, EMPLOYEE_CATEGORY, ESHOP_CATEGORY, NEWS_CATEGORY } from '../stores/SearchStore';
import { findClosestContainer, focusRowInContainer } from './SearchHtmlUtil';
import { AllAndArchivedFilterOrder, DealerNewsFilterOrder } from './SearchInterfaces';

interface SwitchArchiveFilterButtonProps {
  category: typeof NEWS_CATEGORY | typeof ESHOP_CATEGORY | typeof EMPLOYEE_CATEGORY;
  labelPrefix?: string;
  searchStore?: SearchStore;
}

const SwitchArchiveFilterButton = (props: SwitchArchiveFilterButtonProps) => {
  const translate = React.useContext(TranslationsContext).translate;
  const {
    category,
    labelPrefix,
    searchStore: { searchWrappers, changeDealerNewsFilterOrder, changeShopFilterOrder, changeNewsFilterOrder },
  } = props;
  const archivedFilterActive = [AllAndArchivedFilterOrder.ARCHIVED, DealerNewsFilterOrder.ARCHIVED].includes(searchWrappers[category].filterOrder);
  const totalArchived = searchWrappers[category + CATEGORY_ARCHIVED].total;
  const totalAll = searchWrappers[category].total;

  let handleClick: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  const filterOrder = archivedFilterActive ? AllAndArchivedFilterOrder.ALL : AllAndArchivedFilterOrder.ARCHIVED;
  if (category === EMPLOYEE_CATEGORY) {
    handleClick = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      const container = findClosestContainer(event);
      await changeDealerNewsFilterOrder(archivedFilterActive ? DealerNewsFilterOrder.ALL : DealerNewsFilterOrder.ARCHIVED);
      doScrolling(0, 100);
      focusRowInContainer(container, 0);
    };
  } else if (category === ESHOP_CATEGORY) {
    handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      const container = findClosestContainer(event);
      changeShopFilterOrder(filterOrder);
      doScrolling(0, 100);
      focusRowInContainer(container, 0);
    };
  } else {
    handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      const container = findClosestContainer(event);
      changeNewsFilterOrder(filterOrder);
      doScrolling(0, 100);
      focusRowInContainer(container, 0);
    };
  }

  if ((!archivedFilterActive && !totalArchived) || (archivedFilterActive && !totalAll)) {
    return null;
  }

  return (
    <div className="text-center">
      <Separator color="invisible" spacing="small" />
      <AnalyticsTrigger
        trigger={{
          id: `Tab - ${category} - Button - ${archivedFilterActive ? 'all' : 'archived'}`,
          callback: 'onClick',
        }}
      >
        <Button
          iconLeft="#report"
          link={true}
          theme="light"
          text={
            archivedFilterActive
              ? `${translate(`search.${labelPrefix ? `${labelPrefix}.` : ''}all`)} (${totalAll})`
              : `${translate(`search.${labelPrefix ? `${labelPrefix}.` : ''}archived`)} (${totalArchived})`
          }
          onClick={handleClick}
        />
      </AnalyticsTrigger>
    </div>
  );
};

export default inject('searchStore')(observer(SwitchArchiveFilterButton));
